import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Message } from "primereact/message";
import { ProgressSpinner } from "primereact/progressspinner";

import TestReportService from "../../services/TestReport/TestReport.service";
import { generateTestReportPdf } from "../TestReport/TestReportPdf";
import centerLogo from "../../assests/images/DesiriLogo.png";
import qaSeal from "../../assests/images/badge.png";


type Status = "loading" | "success" | "not-found" | "error";

const PublicTestReport = () => {
  const { batchNo } = useParams<{ batchNo: string }>();
  const [status, setStatus] = useState<Status>("loading");

  useEffect(() => {
    if (!batchNo) {
      setStatus("error");
      return;
    }

    const fetchAndDownload = async () => {
      try {
        setStatus("loading");

        const dto = await TestReportService.getPublicReportByBatch(batchNo);

        if (!dto?.meta?.hasTestReport) {
          setStatus("not-found");
          return;
        }
        await generateTestReportPdf({
          meta: {
            reportId: dto.meta.reportId,
            hasTestReport: dto.meta.hasTestReport,
            reportDate: dto.meta.reportDate,
            manufacturingUnitId: dto.meta.manufacturingUnitId,
            manufacturingUnitName: dto.meta.manufacturingUnitName,
            testedDate: dto.meta.testedDate,
            analysisStart: dto.meta.analysisStart,
            analysisEnd: dto.meta.analysisEnd,
            sampleQty: dto.meta.sampleQty,
            testerName: dto.meta.testedByName,
            oilName: dto.meta.oilName,
            batchName: dto.meta.batchName,
          },
          results: dto.results,
          tolerances: new Map(
            Object.entries(dto.tolerances || {}).map(([k, v]: any) => [
              Number(k),
              { min: v.min, max: v.max },
            ])
          ),
          methodByTestId: dto.methodByTestId,
          centerLogoUrl: centerLogo,
          qaSealUrl: qaSeal,
          filename: `TestReport_${batchNo}.pdf`,
        });

        setStatus("success");
      } catch (error) {
        console.error("Public Test Report error:", error);
        setStatus("error");
      }
    };

    fetchAndDownload();
  }, [batchNo]);

 const formatBatchCode = (batchNo?: string) => {
  if (!batchNo) return "—";
  const num = Number(batchNo);
  if (Number.isNaN(num)) return batchNo;
  return `B${num.toString().padStart(8, "0")}`;
};

  return (
    <div
      className="flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "60vh", padding: "1rem", gap: "1rem" }}
    >
      {status === "loading" && (
        <>
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="4"
          />
          <Message
            severity="info"
            text={`Downloading Test Report for Batch ${formatBatchCode(batchNo)}…`}
          />
        </>
      )}

      {status === "not-found" && (
        <Message
          severity="warn"
          text={`Test report not available for Batch ${formatBatchCode(batchNo)}`}
        />
      )}

      {status === "error" && (
        <Message
          severity="error"
          text={`Failed to download Test Report for Batch ${formatBatchCode(batchNo)}`}
        />
      )}

      {status === "success" && (
        <Message
          severity="success"
          text={`Test Report downloaded successfully for Batch ${formatBatchCode(batchNo)}`}
        />
      )}
    </div>
  );
};

export default PublicTestReport;







// import { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";

// const PublicTestReport = () => {
//   const { batchNo } = useParams();
//   const [error, setError] = useState<string>("");

//   useEffect(() => {
//     if (!batchNo) {
//       setError("Batch number is missing");
//       return;
//     }

//     // Direct API download URL
//     const downloadUrl = `${process.env.REACT_APP_SERVER_ENDPOINT}api/TestReport/download/batch/${batchNo}`;
    
//     // Redirect to API endpoint for direct download
//     window.location.href = downloadUrl;
//   }, [batchNo]);

//   return (
//     <div style={{ textAlign: "center", padding: "50px" }}>
//       {error ? (
//         <p style={{ color: "red" }}>{error}</p>
//       ) : (
//         <>
//           <p>Downloading Test Report for Batch {batchNo}...</p>
//           <p style={{ fontSize: "12px", color: "#666", marginTop: "20px" }}>
//             If download doesn't start automatically,{" "}
//             <a 
//               href={`${process.env.REACT_APP_SERVER_ENDPOINT}/api/TestReport/download/batch/${batchNo}`}
//               style={{ color: "#007bff", textDecoration: "underline" }}
//             >
//               click here
//             </a>
//           </p>
//         </>
//       )}
//     </div>
//   );
// };

// export default PublicTestReport;
